import {BehaviorSubject, Observable, of, Subject} from 'rxjs';

import {catchError, switchMap} from 'rxjs/operators';
import {Injectable, NgZone, OnDestroy} from '@angular/core';

import {PreferenceutilisateurDTO} from '../dtos/preferenceutilisateur-dto';
import {UtilsService} from '../utils/utils.service';
import {AUTH, DATES_FORMAT, USER_TYPE_PREFERENCE} from '../constants';
import {Router} from '@angular/router';

import {HttpClient} from '@angular/common/http';
import {FrontStorageService} from './storage/front-storage.service';
import * as moment from 'moment';
import {findIndex as _findIndex, parseInt as _parseInt, split as _split} from 'lodash';

export const URL_SAVE_ALL_PREFERENCES = 'dolrest/gestionpreferences/save';
export const URL_SAVE_ONE_PREFERENCE = 'dolrest/gestionpreferences/save/one';
export const URL_GET_PREFERENCES: string = 'dolrest/gestionpreferences/mypreferences';

@Injectable()
export class PreferencesUtilisateurService implements OnDestroy {


  private preferencesUtilisateur: PreferenceutilisateurDTO[] = this.initPreferencesFromLocalStorage();

  private subjectPrefOfUser = new BehaviorSubject(this.preferencesUtilisateur);
  public preferencesOfUser$ = this.subjectPrefOfUser.asObservable();

  private subjectOpenDialogEditPreferences = new Subject<boolean>();
  openDialogEditPreferences$ = this.subjectOpenDialogEditPreferences.asObservable();

  constructor(
    private http: HttpClient,
    private _ngZone: NgZone,
    private frontStorageSvc: FrontStorageService,
    private router: Router,
    private utils: UtilsService) {

  }

  /**
   * notifier tous les composants abonnés aux preferences utilisateur de mettre à jour leurs preferences
   */
  announcePreferencesUtilisateur = () => {
    if (this.preferencesUtilisateur) {
      this.subjectPrefOfUser.next(this.preferencesUtilisateur);
    }
  };

  /**
   * notifier tous les composants abonnés aux preferences utilisateur de mettre à jour leurs preferences
   * Assigne les nouvelles preferences
   */
  announceAndAssignUserPrefs = (prefs: PreferenceutilisateurDTO[]) => {
    if (!this.utils.isCollectionNullOrEmpty(prefs)) {
      this.preferencesUtilisateur = prefs;
      this.subjectPrefOfUser.next(this.preferencesUtilisateur);
    }
  };

  announceOpenDialogPreferences = () => {
    this.subjectOpenDialogEditPreferences.next(true);
  };

  ngOnDestroy(): void {

  }

  initPreferencesFromLocalStorage() {

    let prefs = this.frontStorageSvc.secureLS.get(AUTH.preferences);
    if (this.utils.isCollectionNullOrEmpty(prefs)) {
      prefs = [];
    }
    return prefs;

  }

  getMyPreferences = (username: string): Observable<PreferenceutilisateurDTO[]> => {
    if (username) {
      return this.http.get(URL_GET_PREFERENCES + `/${username}`).pipe(
        // .do(data=>console.log('myPreferences',username))
        catchError(error => this.utils.handleError(error, true)))
    }

    return of(null);

  };

  savePreference = (key:string, typePref:string, value:any) => {
    this.assignPreferenceUtilisateurValeur(key, typePref, value);
    this.saveOnePreferenceUtilisateur(this.getPreferenceUtilisateur(key)).subscribe(response=> this.frontStorageSvc.secureLS.set(AUTH.preferences, this.preferencesUtilisateur));
  };

  saveOnePreferenceUtilisateur = (preference: PreferenceutilisateurDTO): Observable<PreferenceutilisateurDTO> => {

    if (this.utils.isNullOrEmpty(preference)) {
      return of(null);
    }
    return this.http.post(URL_SAVE_ONE_PREFERENCE, preference).pipe(
      catchError(error => this.utils.handleError(error, true)));
  };


  savePreferencesUtilisateur = (): Observable<PreferenceutilisateurDTO[]> => {

    if (!this.utils.isCollectionNullOrEmpty(this.preferencesUtilisateur)) {
      return this.http.post<PreferenceutilisateurDTO[]>(URL_SAVE_ALL_PREFERENCES, this.preferencesUtilisateur).pipe(
        switchMap(data => {
          this.preferencesUtilisateur = data;
          this.frontStorageSvc.secureLS.set(AUTH.preferences, this.preferencesUtilisateur);

          this.announcePreferencesUtilisateur();
          return of(data);
        }),
        catchError(error => this.utils.handleError(error, true)));
    }
    return of(null);
  };

  assignPreferenceUtilisateurValeur = (key: string, typeValeur: string, newValeur: any) => {
    let prefUser = this.getPreferenceUtilisateur(key);

    if (prefUser) {
      if (typeValeur === USER_TYPE_PREFERENCE.BOOLEAN) {
        prefUser.valeur = newValeur === true ? 'true' : 'false';
      } else if (typeValeur === USER_TYPE_PREFERENCE.NUMBER) {
        prefUser.valeur = newValeur + '';
      } else if (typeValeur === USER_TYPE_PREFERENCE.NUMBERARR) {

        let str = '';
        // prefUser.valeur = '' + newValeur;
        prefUser.valeur = newValeur.reduce((prev, next, i) => {
          if (i < newValeur.length - 1) {
            return prev + next + ',';
          } else {
            return prev + next;
          }

        }, '');

      } else if (typeValeur === USER_TYPE_PREFERENCE.STRING) {

        prefUser.valeur = newValeur;

      } else if (typeValeur === USER_TYPE_PREFERENCE.STRINGARR) {

      } else if (typeValeur === USER_TYPE_PREFERENCE.DATE) {
        prefUser.valeur = this.utils.getYYYYMMDD(moment(newValeur));
      }
    }
  };

  /**
   *
   * @param {string} key --> see USER_PREFERENCE in constants.ts
   * @returns {PreferenceutilisateurDTO}
   */
  getPreferenceUtilisateur = (key: string): PreferenceutilisateurDTO => {

    if (this.preferencesUtilisateur) {
      let idx = _findIndex(this.preferencesUtilisateur, {
        clefPreference: key
      });
      if (idx && idx > -1) {

        // console.log(this.preferencesUtilisateur[idx]);
        return this.preferencesUtilisateur[idx];
      }
    }
    return null;
  };

  getPreferenceUtilisateurValue = (key: string): string => {
    let prefUser = this.getPreferenceUtilisateur(key);
    if (prefUser) {
      return prefUser.valeur;
    }
    return '';
  };

  getPreferenceUtilisateurBooleanValue = (key: string): boolean => {
    let prefUser = this.getPreferenceUtilisateur(key);
    if (prefUser && prefUser.valeur) {
      return prefUser.valeur.trim() === 'true' ? true : false;
    }
    return false;
  };

  getPreferenceUtilisateurDateValue = (key: string): Date => {
    let prefUser = this.getPreferenceUtilisateur(key);
    if (prefUser && prefUser.valeur) {
      return moment(prefUser.valeur, DATES_FORMAT.YYYYMMDD).toDate();
    }
    return undefined;
  };


  getPreferenceUtilisateurIntValue = (key: string): number => {
    let prefUser = this.getPreferenceUtilisateur(key);
    if (prefUser) {
      return +prefUser.valeur;
    }
    return 0;
  };


  getPreferenceUtilisateurArrIntValue = (key: string): number[] => {
    let prefUser = this.getPreferenceUtilisateur(key);
    if (prefUser && prefUser.valeur) {
      let arrStr: string[] = _split(prefUser.valeur, ',');
      if (arrStr) {
        let arrNumber: number[] = [];
        for (let a of arrStr) {
          arrNumber.push(_parseInt(a));
        }
        return arrNumber;
      }
    }
    return null;
  };

  getPreferenceUtilisateurArrStringValue = (key: string): string[] => {
    let prefUser = this.getPreferenceUtilisateur(key);
    if (prefUser && prefUser.valeur) {
      let arrStr: string[] = _split(prefUser.valeur, ',');

      return arrStr;
    }
    return null;
  };

}
